import { gql } from "gql";

export const GET_REGISTRATION_BY_EXTERNAL_CODE = gql(/* GraphQL */ `
  query GetRegistrationByExternalCode($code: String!) {
    getRegistrationByExternalCode(code: $code) {
      ...SignRegistrationForExternalSignPage
    }
  }
`);
